<!-- oficio-instituicao-ensino.component.html -->
<form [formGroup]="form">
  <div class="p-fluid grid">
    <div class="field col-12 d-flex flex-column">
      <label for="instituicao">Instituição de Ensino</label>
      <p-select
        id="instituicao"
        appendTo="body"
        [filter]="true"
        [options]="InstEnsino"
        optionLabel="nome"
        optionValue="id"
        placeholder="Seleccione a instituição"
        formControlName="instituicao"
      ></p-select>
      <small *ngIf="form.get('instituicao')?.touched && form.get('instituicao')?.invalid" class="error-message">
        Instituição é obrigatória.
      </small>
    </div>

    <div class="field col-12 d-flex flex-column">
      <label for="nome">Estudante</label>
      <p-select
        [filter]="true"
        [showClear]="true"
        appendTo="body"
        id="nome"
        formControlName="estudanteID"
        [options]="Estudantes"
        optionLabel="nome"
        optionValue="id"
        placeholder="Seleccione o estudante"
        class="w-full"
      ></p-select>
      <div *ngIf="form.get('estudanteID')?.touched && form.get('estudanteID')?.invalid">
        <small *ngIf="form.get('estudanteID')?.errors?.['required']" class="error-message">
          Nome do estudante é obrigatório.
        </small>
      </div>
    </div>

    <!-- <div class="field col-6 d-flex flex-column">
      <label for="valorBolsa">Valor da Bolsa</label>
      <input
        id="valorBolsa"
        class="input-number-hide-arrow"
        placeholder="800,00"
        type="text"
        mask="separator.2"
        pInputText
        formControlName="valores"
      />
      <div *ngIf="form.get('valores')?.touched && form.get('valores')?.invalid">
        <small *ngIf="form.get('valores')?.errors?.['required']" class="error-message">
          Valor da Bolsa é obrigatório.
        </small>
      </div>
    </div>

    <div class="field col-6 d-flex flex-column" *ngIf="form.get('valores')?.value != null && form.get('valores')?.value !== ''">
      <label for="valorBolsaExt">Valor Extenso da Bolsa</label>
      <input
        id="valorBolsaExt"
        class="input-number-hide-arrow"
        placeholder="Mil e duzentos e oitenta e seis"
        type="text"
        pInputText
        formControlName="valoresextenso"
      />
      <div *ngIf="form.get('valoresextenso')?.touched && form.get('valoresextenso')?.invalid">
        <small *ngIf="form.get('valoresextenso')?.errors?.['required']" class="error-message">
          Valor por extenso é obrigatório.
        </small>
      </div>
    </div> -->

    <div class="field col-12 d-flex flex-column gap-2" *ngIf="form.get('estudanteID')?.value">
      <ng-container *ngIf="pagination.data?.length; else emptyTemplate">
        <span>Tipo de Bolsa: {{ bolsa?.tipoBolsaDescricao }} </span>
        <span>Instituição Gestora: {{ bolsa?.instituicaoGestora?.nome }} </span>
        <span>Área de conhecimento: {{ bolsa?.areaProgramaFormacao?.areaFormacao?.designacao }} </span>
        <span>Valor da Bolsa: {{ valorRegra }} </span>
      </ng-container>
      <ng-template #emptyTemplate>
        <div class="no-data">
          <app-data-void titulo="Nenhum auxílio de formação encontrado" descricao="Clique em adicionar auxílio para criar uma."></app-data-void>
        </div>
      </ng-template>
    </div>

    <div class="field col-12">
      <button pButton type="button" label="Adicionar Estudante" class="search-btn p-3" (click)="addStudent()" aria-label="Adicionar estudante"></button>
    </div>

    <div class="field col-12">
      <p-table [value]="students" showGridlines>
        <ng-template pTemplate="header">
          <tr>
            <th>#</th>
            <th>Nome</th>
            <th>Curso</th>
            <th>Ano/Freq.</th>
            <th>Valor</th>
            <th>Acções</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-student let-i="rowIndex">
          <tr>
            <td>{{ i + 1 }}</td>
            <td>{{ student.nome }}</td>
            <td>{{ student.curso }}</td>
            <td>{{ student.AnoFrequencia }}</td>
            <td>{{ student.valor }}</td>
            <td>
              <button type="button" pButton icon="pi pi-trash" class="p-button-text p-button-danger" (click)="removeStudent(i)"></button>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center">Sem estudantes seleccionados</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</form>

<p-toast />
<p-confirmDialog></p-confirmDialog>
